import { render, staticRenderFns } from "./appointmentReserveView.vue?vue&type=template&id=af5bb1fc&scoped=true"
import script from "./appointmentReserveView.vue?vue&type=script&lang=js"
export * from "./appointmentReserveView.vue?vue&type=script&lang=js"
import style0 from "./appointmentReserveView.vue?vue&type=style&index=0&id=af5bb1fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5bb1fc",
  null
  
)

export default component.exports